import React from 'react';
import { useTranslations } from '@lang';
import { StyledErrorMessage } from './ErrorBox.style';
import { ErrorProps, ErrorType, ErrorCode } from './ErrorBox.type';

function isErrorCode(error: ErrorType): error is ErrorCode {
  return (error as ErrorCode).id !== undefined;
}

export const ErrorBox: React.FC<ErrorProps> = ({ className, error }) => {
  const { t } = useTranslations();
  if (error) {
    return (
      <StyledErrorMessage className={className}>
        {isErrorCode(error) ? t(error.id) : error}
      </StyledErrorMessage>
    );
  }
  return null;
};
